var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rating-chart" },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }),
      ]),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _c("EChartsBar", {
            attrs: {
              labels: _vm.getXAxisData(),
              datasets: _vm.getChartDatasets(),
              height: 320,
              stacked: true,
            },
          }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.totalRatingCount"),
              value: _vm.stats.totalRatingCount,
              unit: _vm.$t("report.rate"),
              description: _vm.$t("report.totalRatingCountDesc"),
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.getTitle("averageRating"),
              value: _vm.formatStat(_vm.stats.AverageRating).value,
              unit: _vm.formatStat(_vm.stats.AverageRating).unit,
              description: _vm.$t("report.averageRatingDesc"),
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.getTitle("weightedAverageRating"),
              value: _vm.formatStat(_vm.stats.WeightedAverageRating).value,
              unit: _vm.formatStat(_vm.stats.WeightedAverageRating).unit,
              description: _vm.$t("report.weightedAverageRatingDesc"),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.stats.totalRatingCount > 0
        ? _c(
            "div",
            { staticClass: "stats" },
            _vm._l(Object.keys(_vm.stats.ratingCounts), function (key) {
              return _c("StatCard", {
                key: key,
                attrs: { title: key, value: _vm.stats.ratingCounts[key] },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }